<div class="row align-items-center">
  <div class="col-6">
    <h2>Artigos</h2>
  </div>
  <div class="col-6 text-end"><button class="btn btn-sm btn-success" (click)="open(content)"><i
        class="bi bi-file-earmark-plus"></i>Novo</button>
    <button class="btn btn-primary btn-sm ms-2" (click)="openImagens(imagens)"><i
        class="bi bi-clipboard-x"></i>Imagens</button>
  </div>
</div>
<table mat-table [dataSource]="dataSource" matSort class="mt-2">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Id
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      {{element.id}} </td>
  </ng-container>
  <ng-container matColumnDef="tema" class="d-none d-lg-block d-xl-none">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Tema"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Tema
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      {{element.tema.nome}} </td>
  </ng-container>
  <ng-container matColumnDef="titulo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by titulo">
      Titulo
    </th>
    <td mat-cell *matCellDef="let element"> {{element.titulo}} </td>
  </ng-container>
  <ng-container matColumnDef="ativo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by symbol">
      Ativo
    </th>
    <td mat-cell *matCellDef="let element"> {{element.ativo?"Sim":"Não" }} </td>
  </ng-container>
  <ng-container matColumnDef="data">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by data"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Data
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      {{element.data | date:'dd/MM/yyyy'}} </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button class="btn btn-sm" (click)="edit(content,row.id)"><i class="bi bi-pen-fill"></i></button>
        <button class="btn btn-sm" (click)="deleteItem(row.id)"><i class="bi bi-trash"></i></button>
        @if (row.permiteComentario==true) {
        <button class="btn btn-sm" (click)="openComentarios(comentarios,row.id)"><i class="bi bi-chat"></i></button>
        }
        <button class="btn btn-sm">
          <span class="fa-stack" (click)="deleteImage(row.id)" style="cursor: pointer;">
            <i class="far fa-image fa-stack-1x" style='font-size:18px'></i>
            <i class="fas fa-slash fa-stack-1x fa-inverse" style='font-size:18px; color:red'></i>
          </span></button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

@if (loading) {
<div style="display: flex; justify-content: center; align-items: center; background: white; margin: 50px;">
  <mat-spinner diameter="40" color="warn"></mat-spinner>
</div>
}

<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Selecione a página">
</mat-paginator>

<ng-template #content let-c="close" let-d="dismiss">
  <form (ngSubmit)="submitForm()" novalidate [formGroup]="formMateria">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Matéria</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Tema</label>
        <select name="idTema" id="idTema" formControlName="idTema" class="form-control">
          @for (tema of temas; track tema) {
          <option [ngValue]="tema.id" convert-to-number>
            {{tema.nome}}
          </option>
          }
        </select>
        @if (submitted && f.idTema.errors) {
        <small class="text-danger">
          @if (f.idTema.errors.required) {
          <span>Tema é obrigatório.</span>
          }
        </small>
        }
      </div>
      <div class="form-group">
        <label>Título</label>
        <input type="text" name="titulo" id="titulo" formControlName="titulo" class="form-control" />
        @if (submitted && f.titulo.errors) {
        <small class="text-danger">
          @if (f.titulo.errors.required) {
          <span>Título é obrigatório.</span>
          }
        </small>
        }
      </div>
      <div class="form-group">
        <label>Imagem atual:</label><br />
        <img src="/imagens/{{imagem}}" class="img-thumbnail" style="max-width: 300px;" />

      </div>
      <div class="form-group">
        <label>Substituir Imagem</label><br />
        <input type="file" name="fileUploadImage" id="fileUploadImage" (change)="prepareImage($event)" />
      </div>
      <div class="form-group">
        <label>Classe</label>
        <select class="form-control" name="classeImagem" id="classeImagem" formControlName="classeImagem">
          <option value="">Selecione</option>
          <option value="float-left image-fluid">Esquerda</option>
          <option value="float-right image-fluid">Direita</option>
          <option value="card-img-top image-fluid pb-3">Imagem Top</option>
        </select>
      </div>
      <div class="form-group">
        <label>Resumo</label>
        <textarea id="resumo" formControlName="resumo" type="text" class="form-control" rows="5"></textarea>
        @if (submitted && f.resumo.errors) {
        <small class="text-danger">
          @if (f.resumo.errors.required) {
          <span>Resumo é obrigatório.</span>
          }
        </small>
        }
      </div>
      <div class="form-group">
        <label>Texto</label>
        <editor [init]="{ plugins: 'lists link image table code help wordcount', height: 600 }"
          apiKey="ucebs9h257hi0y65mcmhki93g8yo59prz68898ozeadwxn04" formControlName="texto" id="texto">
        </editor>
        @if (submitted && f.texto.errors) {
        <small class="text-danger">
          @if (f.texto.errors.required) {
          <span>Texto é obrigatório.</span>
          }
        </small>
        }
      </div>

      <div class="form-group">
        <label>Fonte</label>
        <input id="fonte" formControlName="fonte" type="text" class="form-control" />
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="ativo" formControlName="ativo">
        <label class="form-check-label" for="ativo">
          Ativo
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="ativo" formControlName="permiteComentario">
        <label class="form-check-label" for="permiteComentario">
          Permite Comentario
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-sm-text btn-sm btn-success">Salvar</button>
      <button type="button" class="btn btn-sm-text btn-sm btn-warning" (click)="c('Close click')">Cancelar</button>
      <input type="hidden" name="acao" />
      <input type="hidden" name="id" id="id" formControlName="id" />
      <input type="hidden" name="data" id="data" formControlName="data" />
      <input type="hidden" name="imagemDestaque" id="imagemDestaque" formControlName="imagemDestaque" />
    </div>
  </form>
</ng-template>

<ng-template #imagens let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Matéria</h4>
    <button type="button" class="btn" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Substituir Imagem</label>
      <input type="file" name="files" id="files" multiple />
    </div>
    @if (arquivos) {
    <div class="row">
      <div class="col-4"><b>Imagem</b></div>
      <div class="col-2"><b>Ação</b></div>
      <div class="w-100"></div>
      @for (arquivo of arquivos; track arquivo) {
      <div>
        <div class="col-4">{{arquivo}}</div>
        <div class="col-2"><b>Ação</b></div>
        <div class="w-100"><button class="btn btn-sm"><i class="bi bi-trash"></i></button></div>
      </div>
      }
    </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm-text btn-sm btn-warning" (click)="c('Close click')">Cancelar</button>
  </div>
</ng-template>

<ng-template #comentarios let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Lista de Comentários</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    @if (comentariosMateria.length > 0) {
    <table class="table">
      <tr>
        <th>Nome</th>
        <th>Comentário</th>
        <th></th>
      </tr>
      @for (comentario of comentariosMateria; track comentario) {
      <tr>
        <td>{{comentario.nome}}</td>
        <td><span class="formatted">{{comentario.comentario}}</span></td>
        <td>
          <div class="btn-group" role="group" aria-label="Basic example">
            <button class="btn btn-sm" (click)="openRespostaComentario(comentarioResposta, comentario.id)"><i
                class="bi bi-chat-left-text"></i></button>
            <button class="btn btn-sm" (click)="deleteComentario(comentario.id, comentario.idMateria)"><i
                class="bi bi-trash"></i></button>
            <app-adm-comentario-resposta [comentarioId]="comentario.id"></app-adm-comentario-resposta>
          </div>
        </td>
      </tr>
      }
    </table>
    }
    @if (comentariosMateria.length == 0) {
    <span>Não há comentário para a matéria</span>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm-text btn-sm btn-warning" (click)="c('Close click')">Cancelar</button>
  </div>
</ng-template>

<ng-template #comentarioResposta let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Resposta de Comentario</h4>
    <button type="button" class="btn" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form novalidate [formGroup]="formComentarioResposta" (ngSubmit)="submitFormResposta()">
    <div class="modal-body">
      <div class="form-group">
        <label>Resposta</label>
        <textarea id="resposta" formControlName="resposta" type="text" class="form-control" rows="5"></textarea>
      </div>
      <input type="hidden" formControlName="id" />
      <input type="hidden" formControlName="idComentario" />
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-sm-text btn-sm btn-success">Salvar</button>
      <button type="button" class="btn btn-sm-text btn-sm btn-warning" (click)="c('Close click')">Cancelar</button>
    </div>
  </form>
</ng-template>